<div class="container">
    <span class="pagination-disclaimer" data-testid="pagination-disclaimer">
        <mm-tooltip *ngIf="displayCreateRuleTooltip()" class="create-rule-tooltip" data-testid="create-rule-tooltip" [position]="'top'" [containsLink]="false">
            <tooltip-content>
                <div data-testid="createRuleTooltipText">{{tooltipVerbiage}}</div>
            </tooltip-content>
            <tooltip-trigger-element>
                <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </tooltip-trigger-element>
        </mm-tooltip>
        <sdps-icon *ngIf="showInfoIcon" class="info-icon" color="information" type="functional" name="info" size="small"></sdps-icon>
        <span>{{paginationMessage}}</span>
    </span>
    <mm-total-results [displayedRows]="totalResults"></mm-total-results>
     <div class="selectContainer">
         <span id="inactiveContent">Show</span>
         <div class="selectContainer">
             <select [(ngModel)]="pageSize" (change)="onPageSizeChanged(pageSize)" class="dropDown" id="dropDown">
                 <option value="10" selected="">10</option>
                 <option value="100">100</option>
                 <option value="500">500</option>
             </select>
         </div>
         <span id="inactiveContent">per page</span>
     </div>
     <div id="pageSelector">
         <span id="inactiveContent">Page</span>
         <div *ngIf="numberOfPages>0 ; else elseBlock">
             <select #selectPageChange id="pageNumberSelect" (change)="onPageChanged(selectPageChange.value)" [value]="pageNumber">
                 <option *ngFor="let item of [].constructor(numberOfPages); let i=index">{{i+1}}</option>
             </select>
         </div>
         <ng-template #elseBlock>
             <select id="pageNumberSelect">
                 <option>0</option>
             </select>
         </ng-template>
         <span id="inactiveContent">of {{numberOfPages}}</span>
     </div>
     <div class="pageChangeButton">
         <div class="prevNextButton" [ngClass]="checkPrevButtonIndicator? 'prevButtonTrue': ''">
             <i class="sch-chevron-small-left"></i>
             <span id="prevButton" class="Button" (click)="onBtPrev()">Prev</span>
         </div>
         <span class="prevNextButton">|</span>
         <div class="prevNextButton" [ngClass]="checkNextButtonIndicator? 'nextButtonTrue': ''">
             <span id="nextButton" class="Button" (click)="onBtNext()">Next</span>
             <i class="sch-chevron-small-right"></i>
         </div>
     </div>
 </div>